import './App.css';
import Adabiyot from './Components/Adabiyot';
import Amaliy from './Components/Amaliy';
import { Glossariy } from './Components/Glossariy';
import { Header } from './Components/Header';
import Ilovalar from './Components/Ilovalar';
import { Kurs_ishi } from './Components/Kurs_ishi';
import Maruza from './Components/Maruza';
import { Meyoriyxujjat } from './Components/Meyoriyxujjat';
import Muallif from './Components/Muallif';
import NameLesson from './Components/NameLessom';
import { Taqdimot } from './Components/Taqdimot';
import Test from './Components/Test';
import {Uslubiy} from './Components/Uslubiy';

function App() {
  return (
    <div className="App">
      <div className='header'>
        <Header />
      </div>
      <div className='main'>
        <NameLesson />
        <Maruza />
        <Taqdimot />
        <Amaliy />
        <Ilovalar />
        <Test />
        <Meyoriyxujjat />
        <Adabiyot />
        <Glossariy />
        <Uslubiy />
        <Kurs_ishi />
        <Muallif />
      </div>

    </div>
  );
}

export default App;
